const actions = {
  SET_STATE: 'settingsmenu/SET_STATE',
  GET_DATA: 'settingsmenu/GET_DATA',
}

export default actions
